<template>
  <v-card class="pa-4 mt-6" elevation="0" style="border: 1px solid #f1f5f9; border-radius: 12px;">
    <div class="d-flex align-center mb-4">
      <v-icon color="primary" class="mr-2">mdi-map-marker-radius</v-icon>
      <span class="text-h6 font-weight-bold">ที่ตั้งร้านค้าบนแผนที่</span>
    </div>

    <GoogleMapPicker 
      :value="location"
      @input="onMapInput"
      @change="isChanged = true"
    />

    <!-- Address Detail Field from shared component -->
    <div class="mt-4 px-2">
      <AddressFormFields
        ref="addressForm"
        :value="addressData"
        @input="handleAddressInput"
        :addressRequired="true"
      />
    </div>

    <div class="d-flex justify-end mt-4">
      <v-btn color="primary" @click="saveLocation" :disabled="!isChanged">
        บันทึกตำแหน่งร้าน
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import GoogleMapPicker from "@/components/Shared/GoogleMapPicker.vue";
import AddressFormFields from "@/components/Shared/AddressFormFields.vue";

export default {
  name: "LocationPicker",
  components: { GoogleMapPicker, AddressFormFields },
  props: {
    initialLat: { type: Number, default: 13.7563 },
    initialLng: { type: Number, default: 100.5018 },
    initialAddress: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      location: {
        lat: this.initialLat,
        lng: this.initialLng
      },
      addressData: this.defaultAddressData(),
      isChanged: false
    };
  },
  methods: {
    defaultAddressData() {
      return {
        provinceId: null,
        districtId: null,
        subdistrictId: null,
        province: "",
        district: "",
        subdistrict: "",
        postcode: "",
        postalCode: "",
        addressDetail: ""
      };
    },
    hydrateAddress() {
       const base = this.defaultAddressData();
       this.addressData = { ...base, ...(this.initialAddress || {}) };
    },
    onMapInput(coords) {
      this.location.lat = coords.lat;
      this.location.lng = coords.lng;
      this.isChanged = true;
    },
    handleAddressInput(val) {
      Object.assign(this.addressData, val);
      this.isChanged = true;
    },
    saveLocation() {
      if (this.$refs.addressForm) {
        this.$refs.addressForm.syncNamesForSubmit();
      }
      this.$emit("save", { 
        lat: this.location.lat, 
        lng: this.location.lng,
        addressDetail: this.addressData.addressDetail,
        subdistrictId: this.addressData.subdistrictId,
        postalCode: this.addressData.postalCode || this.addressData.postcode
      });
      this.isChanged = false;
    }
  },
  mounted() {
    this.hydrateAddress();
  },
  watch: {
    initialLat(v) { this.location.lat = v; },
    initialLng(v) { this.location.lng = v; },
    initialAddress: {
      deep: true,
      handler() { this.hydrateAddress(); }
    }
  }
};
</script>

<style scoped>
.map-box {
  width: 100%;
  height: 400px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.coords-display {
  padding: 8px 12px;
  background: #f8fafc;
  border-radius: 6px;
}
</style>
